import React, { useEffect, useRef } from 'react';
import TopNavigation from '../TopNavigation';

const CanadianInfrastructureBlog: React.FC = () => {
  const scenRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!scenRef.current) return;

    const fmt = (v: number) => '$' + v.toFixed(1) + 'M';

    const calc = (cC: number, mC: number) => {
      const lR = 40 * 0.35 + (40 * 0.65) * 0.186;
      const cW = cC * 0.6, cP = cW * 0.35, cR = (cW - cP) * 0.186;
      const cCo = cC * 0.15 * 0.265, cCR = (cC * 0.15 - cCo) * 0.186, cH = cC * 0.13;
      const mW = mC * 0.3, mP = mW * 0.35, mR = (mW - mP) * 0.186;
      const mCo = mC * 0.08 * 0.265, mCR = (mC * 0.08 - mCo) * 0.186, mH = mC * 0.13;
      const ei = 8.16, cpp = 6.60, key = (40 + cC + mC) * 0.4 * 0.25, d = 0.20;
      const tot = lR + cP + cR + cCo + cCR + cH + mP + mR + mCo + mCR + mH + ei + cpp + key + d;
      return { tot, net: 100 - tot, leak: 10 + (20 - cC) + (30 - mC) };
    };

    const scenarios = [
      { l: '90% Buy Canadian', t: 'Made in Canada', cC: 18, mC: 27, mid: false },
      { l: '75% Buy Canadian', t: 'Typical project', cC: 15, mC: 22.5, mid: true },
      { l: '50% Buy Canadian', t: 'Global sourcing', cC: 10, mC: 15, mid: false },
    ];

    scenRef.current.innerHTML = scenarios.map(s => {
      const r = calc(s.cC, s.mC);
      return `<div class="blog-scard${s.mid ? ' mid' : ''}">
        <div class="blog-sl">${s.l}</div>
        <div class="blog-st">${s.t}</div>
        <div class="blog-sr"><span class="blog-k">Stays in Canada</span><span>${fmt(40 + s.cC + s.mC)}</span></div>
        <div class="blog-sr"><span class="blog-k">Leaves Canada</span><span>${fmt(r.leak)}</span></div>
        <div class="blog-sr"><span class="blog-k">Recovered in taxes</span><span>${fmt(r.tot)}</span></div>
        <div class="blog-sr"><span class="blog-k">Real net cost</span><span>${fmt(r.net)}</span></div>
      </div>`;
    }).join('');
  }, []);

  return (
    <>
      <style>{`
        .blog-page {
          font-family: 'Georgia', serif;
          background: #fafaf8;
          color: #1a1a18;
          line-height: 1.85;
          min-height: 100vh;
        }
        .blog-content {
          max-width: 740px;
          margin: 0 auto;
          padding: 3rem 1.5rem 5rem;
        }
        .blog-kicker {
          font-family: sans-serif;
          font-size: 11px;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: #888;
          margin-bottom: 0.75rem;
        }
        .blog-content h1 {
          font-size: clamp(28px, 4vw, 44px);
          font-weight: 700;
          line-height: 1.2;
          margin-bottom: 1rem;
          color: #111;
          font-family: 'Georgia', serif;
        }
        .blog-meta {
          font-family: sans-serif;
          font-size: 12px;
          color: #999;
          padding-bottom: 1.5rem;
          border-bottom: 1px solid #e8e6e0;
          margin-bottom: 1.75rem;
        }
        .blog-lede {
          font-size: 19px;
          font-weight: 300;
          font-style: italic;
          line-height: 1.7;
          margin-bottom: 1.5rem;
          color: #222;
        }
        .blog-content p {
          font-size: 16px;
          font-weight: 300;
          line-height: 1.9;
          margin-bottom: 1.2rem;
          color: #1a1a18;
        }
        .blog-content h2 {
          font-family: 'Georgia', serif;
          font-size: 26px;
          font-weight: 700;
          margin: 2.75rem 0 0.9rem;
          line-height: 1.3;
          color: #111;
        }
        .blog-content h3 {
          font-family: sans-serif;
          font-size: 11px;
          font-weight: 500;
          text-transform: uppercase;
          letter-spacing: 0.09em;
          color: #999;
          margin: 2.25rem 0 0.6rem;
        }
        .blog-content hr {
          border: none;
          border-top: 1px solid #e8e6e0;
          margin: 2.25rem 0;
        }
        .blog-pq {
          border-left: 3px solid #ccc;
          padding: 0.6rem 1.5rem;
          margin: 2rem 0;
          font-family: 'Georgia', serif;
          font-size: 20px;
          font-style: italic;
          line-height: 1.55;
          color: #333;
        }
        .blog-steps { margin: 1.5rem 0; }
        .blog-step { display: flex; gap: 14px; margin-bottom: 1.1rem; align-items: flex-start; }
        .blog-stepnum {
          flex-shrink: 0;
          width: 30px; height: 30px;
          border-radius: 50%;
          background: #f0ede6;
          border: 1px solid #ddd;
          display: flex; align-items: center; justify-content: center;
          font-family: sans-serif;
          font-size: 13px; font-weight: 500;
          margin-top: 3px;
          color: #444;
        }
        .blog-steptext { font-size: 15.5px; font-weight: 300; line-height: 1.8; }
        .blog-steptext strong { font-weight: 500; }
        .blog-numgrid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 12px;
          margin: 1.5rem 0;
        }
        .blog-numbox {
          background: #f5f3ee;
          border-radius: 8px;
          padding: 1rem 1.1rem;
        }
        .blog-bignum {
          font-family: 'Georgia', serif;
          font-size: 34px;
          font-weight: 700;
          line-height: 1;
          color: #111;
        }
        .blog-bignumlabel {
          font-family: sans-serif;
          font-size: 12px;
          color: #777;
          margin-top: 5px;
          line-height: 1.45;
        }
        .blog-scen {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 10px;
          margin: 1.25rem 0 1.5rem;
        }
        .blog-scard {
          border: 1px solid #e0ddd6;
          border-radius: 8px;
          padding: 1rem;
          background: #fff;
        }
        .blog-scard.mid { border-width: 1.5px; border-color: #aaa; }
        .blog-sl {
          font-family: sans-serif;
          font-size: 10px;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          color: #999;
          margin-bottom: 3px;
        }
        .blog-st {
          font-family: sans-serif;
          font-size: 13px;
          font-weight: 500;
          margin-bottom: 10px;
          color: #111;
        }
        .blog-sr {
          display: flex;
          justify-content: space-between;
          font-family: sans-serif;
          font-size: 11px;
          padding: 4px 0;
          border-bottom: 1px solid #f0ede6;
        }
        .blog-sr:last-child { border: none; font-weight: 500; font-size: 12px; padding-top: 7px; }
        .blog-k { color: #999; }
        .blog-disc {
          font-family: sans-serif;
          font-size: 11px;
          color: #aaa;
          line-height: 1.65;
          margin-top: 2.5rem;
          padding-top: 1.25rem;
          border-top: 1px solid #e8e6e0;
        }
        .blog-disc strong { color: #888; }
        @media (max-width: 540px) {
          .blog-numgrid, .blog-scen { grid-template-columns: 1fr; }
        }
      `}</style>

      <TopNavigation onLogin={() => {}} user={null} onLogout={() => {}} />

      <div className="blog-page">
        <div className="blog-content">

          <a href="/blog" style={{display:'inline-block',marginBottom:'1.5rem',fontFamily:'sans-serif',fontSize:'13px',color:'#888',textDecoration:'none'}}>← All Posts</a>

          <div className="blog-kicker">Fiscal Policy · Canadian Infrastructure</div>
          <h1>Investing in Canadian Infrastructure: Don't believe the sticker price</h1>
          <div className="blog-meta">LarrysHelp.org &nbsp;·&nbsp; April 2026 &nbsp;·&nbsp; 5 min read</div>

          <p className="blog-lede">When the government announces a big infrastructure project, everyone argues about the price tag. They're arguing about the wrong number.</p>

          <p>Here's the thing about government spending that nobody explains clearly: when Ottawa spends money in Canada, a big chunk comes back. Through income taxes on workers. Through businesses paying their staff. Through workers spending their paycheques at local shops and restaurants. The money moves around — and at almost every stop, government gets a cut.</p>

          <p>So when you hear "$90 billion for a train" or "$27 billion for a subway" — that's not actually what it costs Canadians. Let's walk through why.</p>

          <hr />

          <h2>Think of it like this</h2>

          <p>Imagine your parents give you $20 to spend at a local market. You buy a sandwich. The shop owner uses that $20 to pay her employee. The employee uses it to buy a coffee down the street. The coffee shop pays its taxes.</p>

          <p>Your parents didn't really "lose" $20. A good chunk came back through taxes and stayed in the neighbourhood. The only money truly gone is what you spent on ingredients that came from somewhere else.</p>

          <p>Public infrastructure works exactly the same way — just with more zeros.</p>

          <hr />

          <h2>Where does the $100M actually go?</h2>

          <p>Picture a typical $100M Canadian infrastructure project — a new transit station, a stretch of highway, a housing development. Here's roughly where the money flows:</p>

          <div className="blog-steps">
            <div className="blog-step">
              <div className="blog-stepnum">1</div>
              <div className="blog-steptext"><strong>$40M to labour.</strong> Canadian workers — ironworkers, electricians, engineers, project managers. They pay income tax at roughly 35%, so about $14M comes straight back to government. Then they spend their take-home pay at Canadian businesses, generating HST and wages for more Canadians.</div>
            </div>
            <div className="blog-step">
              <div className="blog-stepnum">2</div>
              <div className="blog-steptext"><strong>$30M to materials.</strong> Concrete, steel, lumber. A portion is Canadian-made — those factories employ Canadian workers who pay taxes. The HST on invoices flows directly to CRA — it's not a cost to the supplier, it passes straight through to government.</div>
            </div>
            <div className="blog-step">
              <div className="blog-stepnum">3</div>
              <div className="blog-steptext"><strong>$20M to consulting.</strong> Canadian engineering firms. Again — Canadian employees, Canadian payroll taxes, Canadian corporate taxes on profits.</div>
            </div>
            <div className="blog-step">
              <div className="blog-stepnum">4</div>
              <div className="blog-steptext"><strong>$10M to imports.</strong> Specialized equipment from overseas. This money actually leaves Canada. Small duties aside, it's gone — the real leakage.</div>
            </div>
          </div>

          <div className="blog-pq">"The only dollars that truly cost Canadians are the ones that leave Canada. Everything else is a question of how much comes back."</div>

          <hr />

          <h2>Add it all up</h2>

          <p>When you trace every dollar — income taxes on wages, HST flowing through to CRA, corporate taxes on profits, workers spending paycheques locally — and factor in that employed workers aren't collecting Employment Insurance, the fiscal recovery adds up quickly.</p>

          <div className="blog-numgrid">
            <div className="blog-numbox">
              <div className="blog-bignum">$26M</div>
              <div className="blog-bignumlabel">Returned through income tax, HST, and corporate tax</div>
            </div>
            <div className="blog-numbox">
              <div className="blog-bignum">$10M</div>
              <div className="blog-bignumlabel">Returned through workers spending wages locally</div>
            </div>
            <div className="blog-numbox">
              <div className="blog-bignum">$8M</div>
              <div className="blog-bignumlabel">EI payouts avoided + CPP contributions funded</div>
            </div>
          </div>

          <p>Total recovery: roughly <strong>$44M</strong> on a $100M project. The real cost to Canadians — on construction alone — is closer to <strong>$56M</strong>. Not $100M.</p>

          <hr />

          <h2>It matters where you buy</h2>

          <p>The more Canadian content in a project, the more recirculates — and the lower the real cost. Here's what happens when procurement policy changes on the same $100M project:</p>

          <div className="blog-scen" ref={scenRef}></div>

          <p>The gap between a strong domestic procurement policy and a global sourcing approach is about <strong>$9.4M in net fiscal cost</strong> — on the same $100M project, before the asset does anything. That compounds significantly on billion-dollar projects.</p>

          <hr />

          <h2>Three real projects</h2>

          <h3>Alto — Quebec City to Toronto High-Speed Rail</h3>
          <p>The official cost estimate is $60B–$90B — a number that leads every headline and every political attack. Apply the fiscal recovery framework and the real net cost to Canadians is closer to <strong>$26B–$40B</strong>. So the question isn't whether Alto is worth $60B–$90B. It's whether it's worth $26B–$40B to build 1,000 km of rail connecting seven cities at 300 km/h and employ 51,000 Canadians in the process. That's a more interesting debate.</p>

          <h3>Ontario Line — Toronto Subway</h3>
          <p>The cost has grown from $10.9B when announced to $27B today — a real and legitimate cost discipline conversation. But the net fiscal cost after recovery is roughly <strong>$12B</strong>, for a line designed to carry 390,000 riders daily. A subway station built today generates property tax, densification, and development charges for 50+ years. The sticker price is the wrong number to anchor on.</p>

          <h3>Social Housing</h3>
          <p>Take a $400,000 affordable housing unit. After fiscal recovery — income taxes on the construction workers, HST flowing back to CRA, corporate taxes on contractor profits — the real net cost to government is closer to <strong>$176,000</strong>. That's Canadian tradespeople building Canadian homes, with more than half the spend cycling back through the economy before anyone moves in. The case for social housing investment, on construction economics alone, is stronger than the sticker price suggests.</p>

          <hr />

          <h2>One more thing: the age of AI</h2>

          <p>Every country that has built great transit networks, rail corridors, and affordable housing has one thing in common: they stopped arguing about what it costs and started asking what it's worth. Canada is at that moment now — and the timing matters more than ever.</p>

          <p>We are entering an age of AI that will automate more jobs, more quickly, than any previous wave of technology. The question every economy faces is: what do we do with the people? Infrastructure answers that question directly. Building a rail corridor, a subway line, or a housing block employs ironworkers, electricians, engineers, and project managers — people learning real skills, doing work that cannot be offshored or automated away. The train itself might eventually be driven by software. But someone still has to lay the track, pour the concrete, and wire the stations.</p>

          <p>Those jobs build more than infrastructure. They build capability, experience, and self-worth. And when the project is finished, Canadians get to use it. The commuter who shaves 45 minutes off her day. The student who can now afford to live in the city. The family that takes the train to Quebec City for a long weekend because it finally takes three hours instead of six. The economic value is real. So is everything else.</p>

          <div className="blog-pq">"Infrastructure isn't just a cost. It's a decision about what kind of country we want to build — and who we want to keep employed while we build it."</div>

          <p>The sticker price tells you what government writes on the cheque. The net cost — who builds it, how much stays in Canada, and what it generates for decades — that's the whole story.</p>

          <div className="blog-disc">
            <strong>Disclaimer:</strong> All figures illustrative, based on a hypothetical $100M Canadian infrastructure project. Assumed cost split: labour 40%, materials 30%, consulting 20%, imports 10%. Canadian content varies by scenario as shown. Tax rates: blended PIT 35%, corporate 26.5%, HST 13% (flow-through to CRA), import duties ~2%. Keynesian multiplier 1.4x per Conference Board of Canada estimates. EI calculations based on 250 workers, ~10-month average duration, 55% of insurable earnings. CPP at 5.95% employer + employee. Social housing net cost based on $400K unit at 44% recovery rate. Real project outcomes vary by project type, location, procurement, and financing structure. Educational analysis only — not financial or policy advice. Alto cost estimate per Alto's own published range ($60B–$90B). Ontario Line cost per Metrolinx (as of August 2024). Construction costs per Altus Group 2025 Canadian Cost Guide.
          </div>

        </div>
      </div>
    </>
  );
};

export default CanadianInfrastructureBlog;
